import {
  LightWeightObjectChangeTracker,
  SetOptions
} from '@schoolbelle/common/object-change-tracker';
import { SurveyBaseInterface } from './survey.base.interface';
import { Question } from '../../question';
import { orderBy, values, pick, mapValues } from 'lodash';
import { SurveyDataInterface } from './surveyData.interface';

export class SurveyBase extends LightWeightObjectChangeTracker
  implements SurveyBaseInterface {
  protected _questions: { [key: string]: Question } = {};
  get questions(): Question[] {
    return orderBy(values(this._questions), 'priority', 'asc');
  }
  get id(): string {
    return this.get(['id']);
  }
  get version(): string {
    return this.get(['version']);
  }
  get type(): string {
    return this.get(['type']);
  }
  set type(v: string) {
    this.set(['type'], v);
  }
  get timestamp(): number {
    return this.get(['timestamp']);
  }
  get open_at(): number {
    return this.get(['open_at']);
  }
  set open_at(v: number) {
    this.set(['open_at'], v);
  }
  get close_at(): number {
    return this.get(['close_at']);
  }
  set close_at(v: number) {
    this.set(['close_at'], v);
  }
  get created_at(): number {
    return this.get(['created_at']);
  }
  get title(): string {
    return this.get(['title']);
  }
  set title(v: string) {
    this.set(['title'], v);
  }
  get anonymous(): boolean {
    return this.get(['anonymous']);
  }
  set anonymous(v: boolean) {
    this.set(['anonymous'], v);
  }
  get private(): boolean {
    return this.get(['private']);
  }
  set private(v: boolean) {
    this.set(['private'], v);
  }

  get value(): SurveyDataInterface {
    return {
      ...pick(this.get([]), [
        'id',
        'version',
        'type',
        'open_at',
        'close_at',
        'title',
        'anonymous',
        'private',
        'as',
        'uid',
        'timestamp',
        'afterschool_possible_tags',
      ]),
      questions: mapValues(this._questions, question => question.value)
    };
  }

  constructor(survey_id: string = undefined) {
    super();
    if (survey_id) this.set(['id'], survey_id, { push: 'none' });
  }
  public load(
    data: Partial<SurveyDataInterface> = {},
    options: SetOptions = undefined
  ) {
    //overide
    super.load(
      {
        ...data,
        id: this.id
      },
      { push: 'none' }
    );
    // this.notifyChangeThruTree([], options);
  }
}
